module.exports = __webpack_public_path__ + "static/media/auxilioalimentacao.b5835a81.png";